import { AxiosPromise } from 'axios';
import { CrudService } from './CrudService';
import { Args, AxiosConfig, AxiosPagePromise } from './BaseService';
import { resources } from '../resources';
import { UserQueryParams } from '../params/UserQueryParams';
import { UserDto } from '../models/user/UserDto';
import { UserRequest } from '../models/user/UserRequest';
import { UserPreferences } from '../models/user/UserPreferences';
import { Page } from '../models/common/Page';

export class UserService extends CrudService<UserDto, UserQueryParams, UserRequest> {
  constructor() {
    super({
      query: resources.queryCompanyUsers,
      get: resources.getUser,
      create: resources.createQcsUser,
      update: resources.updateUser,
      idKey: 'userId',
    });
  }

  public queryQcsCoreUsers(args?: UserQueryParams, options: AxiosConfig = {}): AxiosPagePromise<UserDto> {
    return this.get<Page<UserDto>>(resources.queryQcsCoreUsers, args as Args, options);
  }

  public getPreferences(userId: string, args?: Args, options?: AxiosConfig): AxiosPromise<UserPreferences> {
    return this.get<UserPreferences>(resources.getUserPreferences, { userId, ...args }, options);
  }

  public updatePreferences(userId: string, body: UserPreferences, args?: Args, options?: AxiosConfig): AxiosPromise<void> {
    return this.put<void>(resources.updateUserPreferences, body, { userId, ...args }, options);
  }
}
